import { twMerge } from 'tailwind-merge';
import { memo, type FC } from 'react';
import { Text } from 'Text';
import { faCloudCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type ContentItemBoxProps } from './ContentItemBox.types';

const ContentItemBoxTextTitle: FC<{
    title: string;
    showCloud?: boolean;
}> = memo(({ title, showCloud = false }) => {
    if (!showCloud) return title;

    // This ensures that the cloud icon does not wrap on its own.
    // if wrapping is needed the last word will be wrapped with the icon
    const words = title.split(' ');
    const lastWord = words.pop();
    const firstWords = words.join(' ');

    return (
        <>
            {firstWords}
            {firstWords && ' '}
            <span className="whitespace-nowrap">
                {lastWord}
                <FontAwesomeIcon
                    icon={faCloudCheck}
                    className="-mt-[2px] ml-[5px] inline align-middle text-xs text-slate-grey-600 md:text-sm"
                />
            </span>
        </>
    );
});

export const ContentItemBoxText: FC<{
    title: string;
    titleSize: ContentItemBoxProps['titleSize'];
    subtitle: string | undefined;
    showCloud?: boolean;
}> = memo(({ titleSize, subtitle, title, showCloud = false }) => {
    const titleClass = twMerge(
        titleSize === 'base' ? 'text-base' : titleSize === 'sm' ? 'text-sm' : 'text-xs',
        'leading-[1.25]',
        subtitle && 'md:leading-none md:mb-0.5',
    );
    const subtitleClass = twMerge(
        titleSize === 'base' ? 'text-base' : titleSize === 'sm' ? 'text-sm' : 'text-xs',
        'leading-[1.25] md:leading-none',
    );

    return (
        <div className="flex flex-grow flex-col">
            <div className="relative">
                <Text color="black" weight="medium" className={titleClass}>
                    <ContentItemBoxTextTitle title={title} showCloud={showCloud} />
                </Text>
            </div>
            {subtitle && (
                <Text color="purple" weight="normal" className={subtitleClass}>
                    {subtitle}
                </Text>
            )}
        </div>
    );
});
